// extracted by mini-css-extract-plugin
export default {"news__row":"style_news__row__amy1F","news__categories":"style_news__categories__Y80Ko","news__categories__title":"style_news__categories__title__crGdA"};